import { useContext } from "react";
import { LearnosityContext } from "../providers/LearnosityProvider";

export const useLearnosity = () => {
  const context = useContext(LearnosityContext);

  if (!context) {
    throw new Error(
      "useLearnosity must be used within a LearnosityProvider"
    );
  }

  return context;
};
